import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { AuthService } from './auth.service';
import { AppSettingsService } from './app-settings.service';
import { ClaimsService } from './claims.service';
import { MenuService } from './menu.service';

@Injectable()
export class LoginAuthorized implements CanActivate {

    constructor(private authService: AuthService,
        private router: Router,
        private appSettingsService: AppSettingsService,
        private menuService: MenuService,
        private claimsService: ClaimsService) {
    }

    canActivate() {
        if (this.authService.isAuthorized()) {
            let route = this.menuService.getDefaultPageUrl(this.claimsService.getUserTypeId());
            this.router.navigate([route]);
            return false;
        }

        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/login-guard.service.ts